import React, {useEffect, useState} from 'react';

import {Block, Button, Card, Dialog, DialogBody, DialogFooter, VF, ModalComponentProps} from '@mc/ui-v4';

import {LayerVO, TopicVO} from '../../../api';
import {WaitForQueryData} from '@mc/react-app-v4';
import {UseQueryResult} from 'react-query';
import {Form, FormRenderProps} from 'react-final-form';
import {useTopicsConfig} from '../../../hooks/useTopicsConfig';
import {useLayersConfig} from '../../../hooks/useLayersConfig';
import {LayerSelectionType} from '../../overhead/content/LayerSelector';

type FormProps = {[key: string]: boolean};

type Props = ModalComponentProps & {
    topic: TopicVO;
    layerType: LayerSelectionType;
    onSubmit: (data: {[key: string]: boolean}) => void;
};

/** Modální dialog pro omezení dostupných podkladových/popisných vrstev na tématu. */
export const LayerSelectorModal: React.FC<Props> = ({onSubmit, onClose, topic, layerType}) => {
    const [availableLayers, setAvailableLayers] = useState<LayerVO[]>();
    const topicsConfigQuery: UseQueryResult<TopicVO[]> = useTopicsConfig();
    const layersConfigQuery: UseQueryResult<{[key: string]: LayerVO}> = useLayersConfig();
    let layerList = layerType === LayerSelectionType.BACKGROUND_LAYER ? topic.backgroundLayers : topic.foregroundLayers;

    const initialValues: FormProps = {};
    for (const layerId of layerList) {
        initialValues[layerId] = true;
    }

    useEffect(() => {
        if (layersConfigQuery.isFetched) {
            let layers: LayerVO[];
            if (layerType === LayerSelectionType.BACKGROUND_LAYER) {
                layers = Object.values(layersConfigQuery.data).filter(l => l.background);
            } else if (layerType === LayerSelectionType.FOREGROUND_LAYER) {
                layers = Object.values(layersConfigQuery.data).filter(l => l.foreground);
            }
            setAvailableLayers(layers);
        }
    }, [layersConfigQuery.isFetched]);

    return (
        <Dialog
            className={'layer-selector-modal'}
            showOnTop
            size="sm"
            onClose={onClose}
            title={`Omezení ${layerType === LayerSelectionType.BACKGROUND_LAYER ? 'podkladových' : 'popisných'} vrstev`}
        >
            <Form<FormProps> initialValues={initialValues} onSubmit={onSubmit}>
                {({submitting, handleSubmit}: FormRenderProps<string[]>) => {
                    return (
                        <>
                            <DialogBody disableScroll>
                                <WaitForQueryData queries={[topicsConfigQuery, layersConfigQuery]}>
                                    {() => {
                                        return (
                                            <Card mode={'edit'} className={'h-100'} bodyClassName={'h-100'}>
                                                <Block>
                                                    Vyberte {layerType === LayerSelectionType.BACKGROUND_LAYER ? 'podkladové' : 'popisné'} vrstvy, které budou
                                                    na téma {topic.label} k dispozici. V případě prázdného výběru budou k dispozici všechny vrstvy.
                                                </Block>
                                                <Block>
                                                    {availableLayers?.map(layer => (
                                                        // Uzavřením id vrstev s tečkami do hranatých závorek se nevytvoří z názvu vnořené pole
                                                        <VF.Checkbox key={layer.id} name={`[${layer.id}]`} label={layer.label} />
                                                    ))}
                                                </Block>
                                            </Card>
                                        );
                                    }}
                                </WaitForQueryData>
                            </DialogBody>
                            <DialogFooter>
                                <Button style="default" disabled={submitting} onClick={onClose}>
                                    Zrušit
                                </Button>
                                <Button style="primary" disabled={submitting} onClick={handleSubmit} type={'submit'}>
                                    Uložit
                                </Button>
                            </DialogFooter>
                        </>
                    );
                }}
            </Form>
        </Dialog>
    );
};
